import React from "react";
import { useRouter } from "next/router";
import ArticlesList from "./ArticlesList";
import Pagination from "./Pagination";
import CategoriesWidget from "./CategoriesWidget";
import MarketingLayout from "../../components/marketing-site/MarketingLayout";
import { IWordpressCategory, IWordpressPost } from "./api";
import { Header } from "./Header";
import { IListing } from "../../lib/interfaces/marketPlace/marketplace";
import LatestVehiclesWidget from "./LatestVehiclesWidget";

export interface IBlogProps {
  posts: IWordpressPost[];
  page: number;
  totalPages: number;
  categories: IWordpressCategory[];
  initData: {
    host: string;
  };
  recentListings: IListing[];
  currentCategory?: IWordpressCategory;
}

function Blog(props: IBlogProps) {
  const {
    posts,
    page: currentPage = 1,
    totalPages,
    categories,
    recentListings,
    currentCategory,
  } = props;

  return (
    <MarketingLayout>
      <section className="bg-gray">
        <Header />
      </section>
      <section className={`bg-white ${currentCategory ? "pt-3" : ""}`}>
        <div className="container">
          {currentCategory && (
            <div className="row mb-3">
              <div className="col-12">
                <h2>Category: {currentCategory.name}</h2>
              </div>
            </div>
          )}
          <div className="row g-5">
            <div className="col-12 col-md-8">
              <ArticlesList posts={posts} />
              <div className="mt-5">
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  pathSegment={
                    currentCategory
                      ? `/blog/category/${currentCategory.slug}`
                      : "/blog"
                  }
                />
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="d-flex flex-column gap-5">
                <CategoriesWidget categories={categories} />
                {recentListings.length && (
                  <LatestVehiclesWidget listings={recentListings} />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}

export default Blog;
